<div class="ssc-login-wrap">
  <section class="ssc-login-left">
    <span class="ssc-badge">SSC PoC Prototype</span>
    <h1>Secure AI Translation & Evaluation Platform</h1>
    <p>On-premises multi-language AI/ML translation prototype for examination content, model evaluation, confidence scoring, language assets, CAT integration and audit governance.</p>
    <div class="ssc-pill-row">
      <span class="ssc-badge green">13+ Indian Languages</span>
      <span class="ssc-badge green">Private Model</span>
      <span class="ssc-badge green">Human-in-the-Loop</span>
    </div>
  </section>

  <section class="ssc-login-right">
    <form class="ssc-login-box" (ngSubmit)="onSignin()">
      <h2>Sign in</h2>
      <div class="ssc-muted">Use your administrator account to access the PoC workspace.</div>

      <label class="ssc-field">
        <span>User ID</span>
        <input name="username" type="text" [(ngModel)]="username" placeholder="ssc.admin" autocomplete="username" />
      </label>

      <label class="ssc-field">
        <span>Password</span>
        <div class="ssc-password-field">
          <input name="password" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" placeholder="Enter password" autocomplete="current-password" />
          <button
            type="button"
            class="ssc-password-toggle"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            (click)="togglePasswordVisibility()"
          >
            {{ showPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
      </label>

      <label class="ssc-login-check">
        <input type="checkbox" [(ngModel)]="rememberMe" name="rememberMe" (change)="onChangeRememberMe($any($event.target).checked)" />
        <span>Remember me</span>
      </label>

      @if (error) {
        <div class="ssc-login-message error">{{ error }}</div>
      }

      @if (loginSuccess) {
        <div class="ssc-login-message success">Sign in details accepted.</div>
      }

      <button type="submit" class="ssc-btn primary ssc-login-submit">Secure Login</button>
      <button type="button" class="ssc-login-link" (click)="goToForgotPassword()">Forgot Password</button>
      <div class="ssc-footer-note">Prototype UI; authentication is bound to the backend JWT login API.</div>
    </form>
  </section>
</div>
